import { GA_ICON_PATH, BOLT_PATH } from "@/components/broadcast/shared";

function IntroSlide({ now }) {
  const words = ["Georgia", "Weather", "Network"];
  return (
    <div className="relative h-full w-full overflow-hidden text-white" data-testid="intro-slide" style={{ background: "linear-gradient(160deg, #0a2a66 0%, #1f63c9 60%, #2a74d8 100%)" }}>
      <div className="absolute inset-0 opacity-[0.1]" style={{ backgroundImage: "repeating-linear-gradient(135deg, #fff 0 2px, transparent 2px 26px)" }} />
      {/* Sweeping broadcast bars */}
      <div className="intro-sweep absolute -left-[60px] top-[160px] h-[90px] w-[1100px] bg-white" style={{ animationDelay: "0ms" }} />
      <div className="intro-sweep absolute -left-[60px] top-[262px] h-[26px] w-[760px] bg-[#ffd60a]" style={{ animationDelay: "120ms" }} />
      <div className="intro-sweep absolute -left-[60px] bottom-[120px] h-[60px] w-[1500px] bg-[#0a0f1c]" style={{ animationDelay: "240ms" }} />
      <div className="absolute left-[120px] top-[168px] font-oswald text-[56px] font-black uppercase tracking-[0.3em] text-[#0a0f1c] intro-rise" style={{ animationDelay: "300ms" }}>You're watching</div>

      {/* Logo + wordmark */}
      <div className="absolute left-[120px] top-[330px] flex items-center gap-12">
        <svg viewBox="-4 -4 108 108" className="intro-flash h-[380px] w-[380px] shrink-0 intro-rise" style={{ animationDelay: "350ms" }} data-testid="intro-logo">
          <path d={GA_ICON_PATH} fill="#0a0f1c" stroke="#fff" strokeWidth="5" strokeLinejoin="round" />
          <path d={BOLT_PATH} fill="#ffd60a" stroke="#0a0f1c" strokeWidth="2" strokeLinejoin="round" />
        </svg>
        <div className="leading-[0.9]">
          {words.map((w, i) => (
            <div key={w} className="intro-rise font-oswald text-[150px] font-black uppercase tracking-tight drop-shadow-[0_14px_30px_rgba(0,0,0,0.35)]" style={{ animationDelay: `${450 + i * 140}ms`, color: i === 1 ? "#ffd60a" : "#fff" }} data-testid={`intro-word-${i}`}>{w}</div>
          ))}
          <div className="intro-line mt-6 h-[10px] w-[760px] bg-white" />
        </div>
      </div>

      {/* Bottom strip */}
      <div className="absolute inset-x-[120px] bottom-[134px] flex items-center justify-between font-oswald text-[30px] font-bold uppercase tracking-[0.35em] text-white intro-rise" style={{ animationDelay: "900ms" }}>
        <span className="flex items-center gap-4"><span className="live-dot" style={{ width: 14, height: 14 }} /> Live · 24/7 · On air</span>
        <span>{now.toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric" })}</span>
      </div>
    </div>
  );
}

export { IntroSlide };
